import React from "react";
import ReactDOM from "react-dom/client";
import "./style/scss/index.scss";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./theme/ThemeProvider";
import { queryClient } from "./query/queryClient";

document.title = import.meta.env.VITE_DOCUMENT_TITLE || "Career Master";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
   <ErrorBoundary>
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ThemeProvider>
            <App />
          </ThemeProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>
    </ErrorBoundary> 
);
